var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#1AB7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9843 8.20804C19.9143 9.7666 18.8243 11.9031 16.7218 14.6136C14.5433 17.4448 12.7048 18.86 11.1955 18.86C10.2556 18.86 9.47697 17.9974 8.82701 16.2728L7.54843 11.5298C7.06846 9.80726 6.5565 8.94465 6.0072 8.94465C5.88721 8.94465 5.4699 9.19664 4.75328 9.69927L4 8.728C4.78356 8.03897 5.56197 7.34411 6.33518 6.64347C7.38711 5.73153 8.17772 5.25357 8.70369 5.20357C9.94827 5.08358 10.7142 5.93685 11.0015 7.76273C11.3115 9.73127 11.5275 10.9552 11.6482 11.4338C12.0081 13.067 12.4028 13.883 12.8327 13.883C13.1674 13.883 13.67 13.3524 14.3426 12.2931C15.0119 11.2332 15.3692 10.4286 15.4172 9.87459C15.5132 8.96065 15.1539 8.50068 14.3413 8.50068C13.9587 8.50068 13.5634 8.58068 13.1567 8.76067C13.9467 6.1835 15.4459 4.92359 17.6644 5.00358C19.313 5.04358 20.0829 6.11284 19.9929 8.20137L19.9843 8.20804Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.a2e64c8876a76962400aeb65c4a61321.svg";
export { ForwardRef as ReactComponent };